export interface Campo {
  id: number;
  descricao: string;
  referencia: string;
  tamanhoMinimo: number;
  tamanhoMaximo: number;
  mascara: string | null;
  obrigatoriedade: boolean;
  tipoCampo: string;
  decimal: number | null;
}

export const CamposNaoVisiveisInsercao = ['ID', 'LINHA'];

export const CamposNaoVisiveisAtualizacao = ['ID'];

export const CamposNaoVisiveisListagem = ['ID'];

export const CamposNaoEditaveis = ['REG', ...CamposNaoVisiveisInsercao];

export const TipoCampo = {
  text: 'text',
  date: 'date',
  number: 'number',
  selectFixo: 'select-fixo',
  selectCampo: 'select-campo',
  selectExterno: 'select-externo',
};

export const TipoCampoSelecionavel = [
  TipoCampo.selectFixo,
  TipoCampo.selectCampo,
  TipoCampo.selectExterno,
];
